import {
  useResponsiveFontSize,
  useResponsiveHeight,
} from '@/components/Util/reactResponsiveDimensions';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import Modal from 'react-native-modal';
import { Modal as TherapistModal } from '@/components/ui/therapist/Modal';
import { Button } from '@/components/ui/therapist/Button';
import ProgressBar from 'react-native-progress/Bar';
import colors from '@/config/colors';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { isPatientApp } from '@/config/constants';
import { useOverlayGuard } from '@/hooks/useOverlayGuard';
import { allowNativeDriver } from '@/utils/allowNativeDriver';

const styles = StyleSheet.create({
  modal: {
    backgroundColor: colors.white,
  },
  content: { flex: 1, alignContent: 'center', justifyContent: 'center' },
  progressBarContainer: {
    width: '60%',
    marginLeft: '20%',
    marginTop: '5%',
    marginBottom: '5%',
  },
  cancelButton: {
    alignSelf: 'center',
    alignContent: 'center',
    justifyContent: 'center',
  },
});

function ProgressModal(props) {
  useOverlayGuard(!!props.isVisible);
  let responsiveStyles = StyleSheet.create({
    text: {
      textAlign: 'center',
      fontSize: useResponsiveFontSize(isPatientApp ? 3 : 2.75),
    },
    cancelText: {
      textAlign: 'center',
      fontSize: useResponsiveFontSize(2),
      color: colors.link,
    },
    cancelButton: {
      padding: useResponsiveFontSize(2),
      borderRadius: useResponsiveFontSize(0.5),
    },
  });

  return (
    <>
      {isPatientApp ? (
        <Modal
          isVisible={props.isVisible}
          animationIn={'fadeIn'}
          animationOut={'fadeOut'}
          useNativeDriver={allowNativeDriver()}
          useNativeDriverForBackdrop={allowNativeDriver()}
          hideModalContentWhileAnimating
          style={styles.modal}
          supportedOrientations={[
            'landscape',
            'landscape-left',
            'landscape-right',
          ]}
        >
          <View style={styles.content}>
            <Text style={responsiveStyles.text}>
              Aufgaben werden heruntergeladen...
            </Text>
            <View style={styles.progressBarContainer}>
              <ProgressBar
                progress={props.progress}
                width={null}
                height={useResponsiveHeight(5)}
                color={colors.primary}
                unfilledColor={colors.lightGrey}
                borderColor={colors.primary}
                useNativeDriver={allowNativeDriver()}
              />
            </View>
            <PressableNeolexon
              onPress={props.cancelAction}
              style={[styles.cancelButton, responsiveStyles.cancelButton]}
            >
              <Text style={responsiveStyles.cancelText}>Abbrechen</Text>
            </PressableNeolexon>
          </View>
        </Modal>
      ) : (
        <TherapistModal
          isVisible={props.isVisible}
          title="Aufgaben werden heruntergeladen..."
          confirmActionButton={
            <Button label="Abbrechen" onPress={props.cancelAction} />
          }
        >
          <ProgressBar
            progress={props.progress}
            width={null}
            height={useResponsiveHeight(5)}
            color={colors.newUI.therapist.primaryBlue80}
            unfilledColor={colors.lightGrey}
            borderColor={colors.newUI.therapist.primaryBlue80}
          />
        </TherapistModal>
      )}
    </>
  );
}

export default ProgressModal;
